<template>
  <div class="ListPanel">
    <HeaderSection 
      :title="title"
      :closeLinkTo="{ name: 'home'}">
      <p>
        De energieke verhalen zijn mogelijk gemaakt door de inzet van vooruitstrevende partijen.
      </p>
      <p>
        <!-- ... Lijst met betrokken partijen, te groeperen per type partij (bijv. gemeente, woningbouw, kennis &amp; netwerk, uitvoeren, leverancier, ...). -->
        Klik op een partij om een lijst met verhalen waar die partij betrokken bij is te bekijken, 
        of klik op de 'verbanden' knop om op de kaart een goed overzicht te krijgen.
      </p>
    </HeaderSection>

    <List 
      :items="items" 
      :sortingBy="sortingBy" 
      :groupBy="groupedBy" 
      type="partijen"
      readmore="tonen" />

    <GroeiTip />
  </div>
</template>

<script>
import List from '@/components/lists/List';
import HeaderSection from '@/components/section/HeaderSection';
import GroeiTip from '@/views/partials/GroeiTip';

export default {
  name: 'ListPartijen',
  components: {
    List,
    HeaderSection,
    GroeiTip
  },
  data() {
    return {
      title: 'Betrokken Partijen',
      sortingBy: [
        {
          key: 'name',
          label : 'A-Z',
          dir: 'ASC'
        }
      ],
      groupedBy: [
        {
          key: 'type',
          label: 'Type',
          dir: 'ASC'
        }
      ]
    }
  },
  computed: {
    items() {
      let items = this.$store.getters.getPartijenList;
      items.forEach((item) => {
        item.to = { name: 'partij-beknopt', params: { slug: item.slug } };
        return item;
      });

      return items;
    }
  },
  destroyed() {
    if (this.$store.map) {
      this.$store.map.setFilter('verhalen', ['all']);
      this.$store.map.setFilter('verhalen_muted', ['==', 'type', 'off']);
    }
  }
}
</script>

<style lang="scss">

  .ListPanel {
    height: 100%;
    display: flex;
    flex-direction: column;

    .List {
      width: 100%;
      flex-grow: 1;
    }
  }

</style>
